import React, { useState } from 'react';
import { allCars } from '../components/carData';

import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaClock } from 'react-icons/fa';
import { SiToyota, SiFord, SiMercedes, SiJeep, SiBmw, SiAudi } from 'react-icons/si';

import BlogList from '../components/BlogList';

const carTypes = ['Select car type', ...new Set(allCars.map(car => car.type)), 'Luxury'];

const indianStatesAndUTs = [
  'Select place',
  'Andaman and Nicobar Islands',
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chandigarh',
  'Chhattisgarh',
  'Dadra and Nagar Haveli and Daman and Diu',
  'Delhi',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu and Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Ladakh',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
];

// --- Booking Form Component (Unchanged) ---
const BookingForm = () => {
  const [formData, setFormData] = useState({});
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    
    try {
      const response = await fetch('http://localhost:4000/api/booking/book_car', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
        credentials: 'include', // Send cookies for session check (ensureAuth)
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`Success! ${data.message} Please call us at ${data.companyPhone} to confirm.`);
        setMessageType('success');
      } else if (response.status === 401) {
        setMessage('You must be logged in to book a car. Please sign in or sign up!');
        setMessageType('error');
      } else {
        setMessage(data.message || 'Booking failed. Check all required fields and try again.');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setMessage('Network error. Could not connect to the server.');
      setMessageType('error');
    }
  };


  return (
    <div className="bg-slate-800 rounded-3xl shadow-xl p-8 transition-all duration-300 ease-in-out hover:scale-[1.01] hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.3)]">
      <h2 className="text-2xl font-bold text-white mb-6">Book your car</h2>

      {/* Success/Error Message Display */}
      {message && (
        <div 
          className={`p-3 rounded-lg mb-4 font-semibold ${
            messageType === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'
          }`}
        >
          {message}
        </div>
      )}
      
      <form onSubmit={handleFormSubmit} className="space-y-5">
        
        <div>
          <label htmlFor="carType" className="block text-sm font-medium text-slate-400 mb-1">Car type</label>
          <select 
            id="carType" 
            name="carType" 
            onChange={handleFormChange}
            required
            className="w-full border-b-2 border-amber-400 bg-slate-700 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            defaultValue="Select car type"
          >
            {carTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="placeOfRental" className="block text-sm font-medium text-slate-400 mb-1">Place of rental</label>
          <select 
            id="placeOfRental" 
            name="placeOfRental" 
            onChange={handleFormChange}
            required
            className="w-full border-b-2 border-amber-400 bg-slate-700 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            defaultValue="Select place"
          >
            {indianStatesAndUTs.map(place => (
              <option key={place} value={place}>{place}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="placeOfReturn" className="block text-sm font-medium text-slate-400 mb-1">Place of return</label>
          <select 
            id="placeOfReturn" 
            name="placeOfReturn" 
            onChange={handleFormChange}
            className="w-full border-b-2 border-amber-400 bg-slate-700 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            defaultValue="Select place"
          >
            {indianStatesAndUTs.map(place => (
              <option key={place} value={place}>{place}</option>
            ))}
          </select>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="rentalDate" className="block text-sm font-medium text-slate-400 mb-1">Rental date</label>
            <input 
              type="date" 
              id="rentalDate" 
              name="rentalDate"
              onChange={handleFormChange}
              required
              className="w-full border-b-2 border-amber-400 bg-slate-700 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            />
          </div>
          <div>
            <label htmlFor="returnDate" className="block text-sm font-medium text-slate-400 mb-1">Return date</label>
            <input 
              type="date" 
              id="returnDate" 
              name="returnDate"
              onChange={handleFormChange}
              className="w-full border-b-2 border-amber-400 bg-slate-700 rounded-lg p-3 text-white focus:ring-amber-400 focus:border-amber-400"
            />
          </div>
        </div>
        
        <button 
          type="submit"
          className="w-full bg-amber-400 text-slate-950 font-bold py-3 px-6 rounded-lg hover:bg-amber-500 transition duration-300"
        >
          Book now
        </button>
      </form>
    </div>
  );
}

// --- Logo Banner Component (Unchanged) ---
const LogoBanner = () => (
  <section className="bg-slate-950 py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-800">
    <div className="max-w-7xl mx-auto flex flex-wrap justify-around items-center gap-8">
      <SiToyota className="text-5xl text-slate-400" />
      <SiFord className="text-5xl text-slate-400" />
      <SiMercedes className="text-5xl text-slate-400" />
      <SiJeep className="text-5xl text-slate-400" />
      <SiBmw className="text-5xl text-slate-400" />
      <SiAudi className="text-5xl text-slate-400" />
    </div>
  </section>
);

// --- Info Item Component (Unchanged) ---
const InfoItem = ({ icon, title, text }) => (
  <div className="flex items-center space-x-4">
    <div className="bg-amber-400 text-slate-950 rounded-full p-4 flex-shrink-0">
      {icon}
    </div>
    <div className="text-left">
      <h4 className="font-bold text-white">{title}</h4>
      <p className="text-slate-400 text-sm">{text}</p>
    </div>
  </div>
);

// --- Main Contact Page Component ---
const Contact = () => {
  // CHANGED ADDRESS TO PATNA, BIHAR, INDIA
  const mapAddress = "Patna, Bihar, India"; 
  
  return (
    <div className="about-page-bg">
      <section className="bg-slate-900 pt-20 pb-10 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-amber-400 mb-0">Contact Us</h1>
        </div>
      </section>

      <section className="radial-gradient-bg py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Left Side: Get in Touch with Us (Updated Address Text) */}
          <div className="bg-slate-800 rounded-3xl p-8 shadow-lg transition-all duration-300 ease-in-out hover:shadow-[0_0_50px_10px_rgba(251,191,36,0.5)] hover:scale-[1.02]">
            <h2 className="text-3xl font-bold text-white mb-6">Get in touch with us</h2>
            <div className="flex flex-col space-y-6">
              <InfoItem 
                icon={<FaMapMarkerAlt size={24} />}
                title="Address"
                text={mapAddress}
              />
              <InfoItem 
                icon={<FaEnvelope size={24} />}
                title="Email"
                text="QuickWheelsSupport@gmail.com"
              />
              <InfoItem 
                icon={<FaPhoneAlt size={24} />}
                title="Phone"
                text="+537 547-6401"
              />
              <InfoItem 
                icon={<FaClock size={24} />}
                title="Opening hours"
                text="Sun - Mon: 10am - 10pm"
              />
            </div>
          </div>
          
          {/* Right Side: Map Section (Embed URL using the new address) */}
          <div className="bg-slate-800 rounded-2xl min-h-[500px] shadow-lg overflow-hidden relative">
            <iframe 
              title="Quick Wheels Location"
              // CRITICAL FIX: The map query now uses the Patna address
              src={`https://maps.google.com/maps?q=${encodeURIComponent(mapAddress)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy"
              className="rounded-lg absolute inset-0 w-full h-full"
            ></iframe>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <BookingForm />
        </div>
      </section>

      <BlogList />
    </div>
  );
}

export default Contact;
